import { render, staticRenderFns } from "./AdminPendingVolunteerDetail.vue?vue&type=template&id=52a12a93&scoped=true&"
import script from "./AdminPendingVolunteerDetail.vue?vue&type=script&lang=js&"
export * from "./AdminPendingVolunteerDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingVolunteerDetail.vue?vue&type=style&index=0&id=52a12a93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a12a93",
  null
  
)

export default component.exports